<template>
  <div class="card">
    <div class="card-header">
      <h5>Customer Report</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Customer Creation Date Range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="From Date"
                id="customer_creation_from"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="customer_creation_from.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
                :max-date="customer_creation_to.date"
              />
              <small class="text-danger" v-if="errors.customer_creation_from">{{ errors.customer_creation_from }}</small>
            </div>
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="To Date"
                id="customer_creation_to"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="customer_creation_to.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
                :min-date="customer_creation_from.date"
              />
              <small class="text-danger" v-if="errors.customer_creation_to">{{ errors.customer_creation_to }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <h6>Brochure Date Range</h6>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="From Date"
                id="customer_brochure_from"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="customer_brochure_from.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
                :max-date="customer_brochure_to.date"
              />
              <small class="text-danger" v-if="errors.customer_brochure_from">{{ errors.customer_brochure_from }}</small>
            </div>
            <div class="col-md-6">
              <dateTimePicker
                no-label
                label="To Date"
                id="customer_brochure_to"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
                v-model="customer_brochure_to.date"
                :only-date="true"
                button-color="#ec391e"
                color="#ec391e"
                style="border: 1px solid #DFE5F9"
                :min-date="customer_brochure_from.date"
              />
              <small class="text-danger" v-if="errors.customer_brochure_to">{{ errors.customer_brochure_to }}</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-3">
          <label class="form-label">
            Report with
          </label>
          <v-select
            v-model="selectedReportWith"
            label="name"
            class="v-select--medium"
            :options="report_with"
            placeholder="Report With"
          >
          </v-select>
          
        </div>
        <div class="col-md-3">
            <label for="checkbox" class="form-label">Emails Opt-out customers</label>
            <v-select
              v-model="opt_out_emails_customer"
              label="name"
              class="v-select--medium"
              :options="[{
                slug: 'include_opt_out',
                name: 'Include Opt-Out'
              },
              {
                slug: 'exclude_opt_out',
                name: 'Exclude Opt-Out'
              },
              {
                slug: 'only_opt_out',
                name: 'Only Opt-Out'
              }
              ]"
              placeholder="Report With"
            >
            </v-select>
        </div>
        <div class="col-md-3">
            <label for="checkbox" class="form-label">Mailing Opt-out customers</label>
            <v-select
              v-model="opt_out_mailing_customer"
              label="name"
              class="v-select--medium"
              :options="[{
                slug: 'include_opt_out',
                name: 'Include Opt-Out'
              },
              {
                slug: 'exclude_opt_out',
                name: 'Exclude Opt-Out'
              },
              {
                slug: 'only_opt_out',
                name: 'Only Opt-Out'
              }
              ]"
              placeholder="Report With"
            >
            </v-select>
        </div>
        <div class="col-md-3">
            <label for="checkbox" class="form-label">Blacklisted customers</label>
            <v-select
              v-model="blacklisted_mailing_customer"
              label="name"
              class="v-select--medium"
              :options="[{
                slug: 'include_blacklisted',
                name: 'Include Blacklisted'
              },
              {
                slug: 'exclude_blacklisted',
                name: 'Exclude Blacklisted'
              },
              {
                slug: 'only_blacklisted',
                name: 'Only Blacklisted'
              }
              ]"
              placeholder="Blacklisted customers"
            >
            </v-select>
        </div>
      </div>
    </div>
    <div class="card-footer align-items-right">
      <button
        type="submit"
        class="button"
        v-on:click.prevent="getBookingReport"
      >
        Generate report
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: "CustomerReportFields",
  data() {
    return {
      customer_creation_from: {},
      customer_creation_to: {},
      customer_brochure_from: {},
      customer_brochure_to: {},
      errors: {
        customer_creation_from:null,
        customer_creation_to:null,
        customer_brochure_from:null,
        customer_brochure_to:null
      },
      report_with: [
        {
          slug:'brochure_requests',
          name:'With Brochure Requests'
        },
        {
          slug:'without_brochure_requests',
          name:'Without Brochure Requests'
        },
        {
          slug:'both',
          name:'Both'
        },
      ],
      selectedReportWith:null,
      opt_out_emails_customer: {
        slug: 'exclude_opt_out',
        name: 'Exclude Opt-Out'
      },
      opt_out_mailing_customer: {
        slug: 'exclude_opt_out',
        name: 'Exclude Opt-Out'
      },
      blacklisted_mailing_customer: {
        slug: 'exclude_blacklisted',
        name: 'Exclude Blacklisted'
      },
    };
  },
  methods: {
    getBookingReport() {
      this.validateFields()
          .then((response) => {
            if (response) {
              this.$store.dispatch("setLoadStatus");
              const request = {
                customer_creation_from:this.customer_creation_from.date,
                customer_creation_to:this.customer_creation_to.date,
                customer_brochure_from:this.customer_brochure_from.date,
                customer_brochure_to:this.customer_brochure_to.date,
                opt_out_emails_customer:(this.opt_out_emails_customer) ? this.opt_out_emails_customer.slug : null,
                opt_out_mailing_customer: (this.opt_out_mailing_customer) ? this.opt_out_mailing_customer.slug : null,
                blacklisted_mailing_customer: (this.blacklisted_mailing_customer) ? this.blacklisted_mailing_customer.slug : null,
                report_with : (this.selectedReportWith) ? this.selectedReportWith.slug : null
              }
              fetch(this.$api + 'reports/customer-detail-report', {
                method: 'POST',
                body: JSON.stringify(request),
                headers:{
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Authorization': localStorage.getItem('token')
                }
              })
              .then((res) => {
                // console.log(res);
                if(res.status === 200) {
                  this.$store.dispatch('setLoadStatus')
                  res.blob().then(response => {
                    const _url = window.URL.createObjectURL(response)
                    const link = document.createElement('a')
                    link.href = _url
                    link.setAttribute('download', 'Customer-Details-Report.xlsx')
                    document.body.appendChild(link)
                    link.click();
                  })
                } else {
                  this.$store.dispatch('setLoadStatus')
                  Promise.race([res.json()])
                  .then(response => {
                    if(response.message) {
                      this.$notify({
                        type: 'error',
                        title: response.message
                      });
                    } else {
                      this.$notify({
                        type: 'error',
                        title: response.error
                      });
                    }
                  })
                }
              })
              
            }
          })
          .catch(error => console.log(error))
    },
    validateFields(){

      let This = this

      return new Promise((resolve, reject) => {

        let errorCount = 0;
        This.errors = {
          customer_creation_from:null,
          customer_creation_to:null,
          customer_brochure_from:null,
          customer_brochure_to:null
        }

        // Booking Dates validation
        if(!This.customer_creation_from.date){
          This.errors.customer_creation_from = "Please select a valid from date"
          errorCount +=1
        }else if(This.customer_creation_from.date && !This.customer_creation_to.date){
          This.errors.customer_creation_to = "Please select a valid to date"
          errorCount +=1
        }else{
          This.errors.customer_creation_from = null
          This.errors.customer_creation_to = null
        }

        if(errorCount == 0 ){
          resolve(true)
        }else{
          reject(true)
        }

      })
    }
  }
};
</script>
